<!--  -->
<template>
  <div class="sp_view">
    <!-- <template v-if="!QRcodeshowQ"> -->
    <!-- <div class="tabselecr_box">
      <div>
        <el-input v-model="query.suite_id" clearable style="width:300px;" placeholder="请输入应用id" />
        <el-input v-model="query.keywords" clearable style="width:400px;margin:0 10px" placeholder="请输入企业名称/企业id" />
        <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <el-button type="warning" icon="el-icon-thumb" @click="anthall">授权</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
      </div>
    </div> -->
    <div class="search-inner">
      <el-input v-model="query.keywords" clearable style="width:200px;" placeholder="请输入企业名称/企业id" @keyup.enter="keyDown($event)" />
      <el-button icon="el-icon-search" type="success" size="mini" @click="searchclick" />
    </div>
    <div class="all_box">
      <div class="left_box">
        <el-table
          ref="singleTable"
          v-loading="loading"
          highlight-current-row
          :data="tableData"
          max-height="773"
          border
          @row-click="handleCurrentChange"
        >
          <el-table-column
            prop="corp_name"
            label="企业名称"
            align="center"
          >
            <template slot-scope="scope">
              <div style="width:100%;height:100%;cursor: pointer">{{ scope.row.corp_name }}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          layout="prev, pager, next"
          :total="total"
          :current-page="query.page"
          @current-change="fetchCurrentPage"
        /> -->
        <!-- <el-button @click.stop="setCurrent()">取消选择</el-button> -->
      </div>
      <div class="right_box">
        <enter ref="enterview" @on-child-click="updateData" />
      </div>
    </div>

    <el-dialog
      title="选择服务商"
      :visible.sync="choosecontet"
      :append-to-body="true"
      width="20%"
    >
      <el-select v-model="value" placeholder="请选择服务商">
        <el-option
          v-for="item in options"
          :key="item.provider_id"
          :label="item.provider_name"
          :value="item.provider_id"
        />
      </el-select>
      <div style="margin-top:20px">
        <el-button type="primary" @click="choosesumbit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="企业授权"
      :visible.sync="lookpassword"
      :append-to-body="true"
      width="30%"
    >
      <div
        v-loading="loadinglink"
        class="qr_box"
        element-loading-background="transparent"
      >
        <img v-if="link!=''" v-loading="loadinglink" :src="link" style="width:200px;height:200px">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { spCorplist, spCorpfetchCorpUsers, authPage, supplierlist, loaddown } from '@/api/officialaccount.js'
import enter from './components/enter.vue'
export default {
  name: 'EnterpriseAstaff',
  components: { enter },
  data() {
    return {

      options: [],
      value: null,
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 200,
        keywords: null,
        suite_id: null
      },
      link: '',
      loadinglink: false,
      lookpassword: false,
      choosecontet: false,
      currentRow: null,

      corp_user_id: '',
      arr: [{ name: 2, id: 3 }, { name: 2, id: 4 }, { name: 3, id: 5 }, { name: 3, id: 6 }, { name: 1, id: 1 }, { name: 1, id: 2 }]
    }
  },
  created() {
    this.list()
    // this.sub()
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown)
  },
  activated() {
    this.list()
  },
  destroyed() {
    // 销毁事件
    window.addEventListener('keydown', this.keyDown)
  },
  methods: {
    updateData(value) {
      console.log(value, 'value')
      console.log(this.QRcodeshowQ, 'QRcodeshowQ1')
      this.QRcodeshowQ = value
      console.log(this.QRcodeshowQ, 'QRcodeshowQ2')
    },
    sub() {
      this.sortArr(this.arr, 'ids')
      console.log(this.sortArr(this.arr, 'ids'))
    },
    sortArr(arr, str) {
      var _arr = []
      var _t = []
      // 临时的变量
      var _tmp

      // 按照特定的参数将数组排序将具有相同值得排在一起
      arr = arr.sort(function(a, b) {
        var s = a[str]
        var t = b[str]

        return s < t ? -1 : 1
      })

      if (arr.length) {
        _tmp = arr[0][str]
      }
      // console.log( arr );
      // 将相同类别的对象添加到统一个数组
      for (var i in arr) {
        console.log(_tmp)
        if (arr[i][str] === _tmp) {
          console.log(_tmp)
          _t.push(arr[i])
        } else {
          _tmp = arr[i][str]
          _arr.push(_t)
          _t = [arr[i]]
        }
      }
      // 将最后的内容推出新数组
      _arr.push(_t)
      return _arr
    },
    async list() {
      this.loading = true
      const data = await spCorplist(this.query)
      data.data.list.unshift({
        corp_name: '员工池'
      })
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('this.$route', this.$route.params)
      // eslint-disable-next-line eqeqeq
      const status = JSON.stringify(this.$route.params) == '{}'
      if (status === false) {
        const index = this.tableData.findIndex((items) => {
          return items.corp_id === this.$route.params.corp_id
        })
        this.$refs.singleTable.setCurrentRow(this.tableData[index])
        console.log('data', data)
      } else {
        console.log('111')
      }
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    keyDown(e) {
      // eslint-disable-next-line eqeqeq
      if (e.key == 'Enter') {
        this.query.page = 1
        this.list()
        e.preventDefault() // 去掉默认的换行
      }
    },

    rechargeclick() {
      this.query.page = 1
      this.query.suite_id = null
      this.query.keywords = null
      this.list()
    },
    choosesumbit() {
      if (this.value === null) {
        this.$message({
          message: '请选择服务商',
          type: 'error'
        })
        return
      }
      this.anth()
      this.choosecontet = false
      this.lookpassword = true
    },
    async anthall() {
      console.log('授权')
      this.value = null
      this.options = []
      this.supplier()
      this.choosecontet = true
    },
    async supplier() {
      const data = await supplierlist()
      this.options = data.data.provider_list

      console.log('data', data.data.provider_list)
    },
    async anth() {
      console.log('授权')
      try {
        this.link = ''
        this.lookpassword = true
        this.loadinglink = true
        const data = await authPage({
          corp_provider_id: this.value
        })
        this.loadinglink = false
        this.link = data.data.qrcode_url
        console.log('data', data.data.qrcode_url)
      } catch {
        this.loadinglink = false
      }
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row)
    },
    handleCurrentChange(val) {
      console.log('val', val)
      if (val.corp_name === '员工池') {
        console.log('员工池')
      } else {
        // this.loadpush(val)
        // this.loadgroup(val.corp_id)
      }
      this.$nextTick(() => {
        this.$refs.enterview.send(val)
      })
      this.currentRow = val
    },
    async loadpush(item) {
      console.log('item', item)
      const data = await spCorpfetchCorpUsers({
        suite_id: item.suite_id,
        corp_id: item.corp_id
      })
      // this.$message({
      //   message: '拉取成功',
      //   type: 'success'
      // })
      console.log('data', data)
    },
    async loadgroup(id) {
      const data = await loaddown({
        corp_id: id
      })
      // this.$message({
      //   message: '拉取群聊成功',
      //   type: 'success'
      // })
      // this.menuList()
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.qr_box{
  text-align: center;
}
.left_box{
  width: 200px;
  margin-right: 40px;
}
.all_box{
  display: flex;
}
.right_box{
  /* width: 1400px; */
  width: 85%;
}
.search-inner{
  margin-bottom:10px;
  display:flex;
    gap:10px;
}
@media (max-width: 768px){
  .search-inner{
    align-items:center;
    justify-content:center;
  }
  .all_box{
    flex-direction:column;
    align-items:center;
  }
  .left_box{
    margin:0px;
    margin-bottom:5vw;
  }
  .right_box{
    width:100%;
  }
}
</style>
